import ApiMsProjectsService from '@/services/ms_projects_service'
import BaseService from "../../services/base_service"

const requestMaterialsService = new BaseService(
  process.env.VUE_APP_MS_REQUESTS_MATERIALS_URL,
  process.env.VUE_APP_MS_REQUESTS_MATERIALS_API_KEY
)

export const state = {
  totalPercentageProjectOrPresale: 0,
  loading: false,
  loadingSyncProjects: false,
  projects: [],
  filteredProjects: [],
  listProjects: [],
  places: [],
  specialPanels: [],
  stagesProjects: [],
  projectInfo: {},
  projectInfoDetailAndTecnical: {},
  currentProject: null,
  //New List For Change Projects Residential
  typeProjectProducts: [],
  saleOrders: {
    items: [],
    total_pages: 0,
    total_items: 0,
  },
}

export const getters = {
  totalPercentageProjectOrPresale: (state) => state.totalPercentageProjectOrPresale,
  loading: (state) => state.loading,
  projects: (state) => state.projects,
  stagesProjects: (state) => state.stagesProjects,
  filteredProjects: (state) => state.filteredProjects,
  listProjects: (state) => state.listProjects,
  places: (state) => state.places,
  specialPanels: (state) => state.specialPanels,
  loadingSyncProjects: (state) => state.loadingSyncProjects,
  projectInfo: (state) => state.projectInfo,
  currentProject: (state) => state.currentProject,
  projectInfoDetailAndTecnical: (state) => state.projectInfoDetailAndTecnical,
  typeProjectProducts: (state) => state.typeProjectProducts,
  saleOrders: (state) => state.saleOrders,
}

export const mutations = {
  SET_TOTAL_PERCENTAGE_PROJECT_OR_PRESALE(state, payload) {
    state.totalPercentageProjectOrPresale = payload
  },
  SET_LOADING(state, payload) {
    state.loading = payload
  },
  SET_PROJECTS(state, payload) {
    state.projects = payload.map((item) => ({
      ...item,
      custom_code: `${item.code} - ${item.name}`
    }))
  },
  SET_CURRENT_PROJECT(state, payload) {
    state.currentProject = payload
  },
  SET_STAGES_PROJECTS(state, payload) {
    state.stagesProjects = payload.map((item) => ({
      name: item,
    }))
  },
  SET_PROJECT_INFO(state, payload) {
    state.projectInfo = payload.project
  },
  SET_PROJECT_INFO_DETAIL_AND_TECNICAL(state, payload) {
    state.projectInfoDetailAndTecnical = payload
  },
  SET_FILTERED_PROJECTS(state, payload) {
    state.filteredProjects = payload
  },
  SET_LIST_PROJECTS(state, payload) {
    state.listProjects = payload
    state.listProjects.projectlist = payload.projectlist.map(item => {
      return {
        ...item,
        name_code: `${item.code} - ${item.name}`
      }
    })
  },
  SET_PLACES(state, payload) {
    let places = []
    payload.forEach((project) => {
      places = [...places, ...project.places]
    })
    state.places = places
  },
  SET_NEW_SPECIAL_PANEL(state, payload) {
    state.specialPanels.unshift(payload)
  },
  SET_SPECIAL_PANELS(state, payload) {
    state.specialPanels = payload
  },
  SET_LOADING_SYNC_PROJECTS(state, payload) {
    state.loadingSyncProjects = payload
  },
  SET_SALE_ORDERS(state, payload) {
    state.saleOrders = payload
  },
  SET_TYPE_PROJECT_PRODUCTS(state, payload) {
    state.typeProjectProducts = payload && payload.items ? payload.items : []
  }
}

export const actions = {
  async getTotalPercentageProjectOrPresale({ commit }, payload = {}) {
    commit('SET_TOTAL_PERCENTAGE_PROJECT_OR_PRESALE', null)
    try {
      const resp = (await ApiMsProjectsService.get(`/documents/get_total_completion_percentage`, payload)).data
      commit('SET_TOTAL_PERCENTAGE_PROJECT_OR_PRESALE', resp)
      return resp
    } catch (error) {
      return error
    }
  },
  clearTotalPercentageProjectOrPresale({ commit }) {
    commit('SET_TOTAL_PERCENTAGE_PROJECT_OR_PRESALE', null)
  },
  async getAllProjects({ commit }, payload = {}) {
    try {
      const resp = (await ApiMsProjectsService.get(`/all_projects`, payload)).data
      commit('SET_PROJECTS', resp)
      commit('SET_PLACES', resp)
      return resp
    } catch (error) {
      return error
    }
  },
  async getProjectFromCode({ commit }, payload = {}) {
    try {
      const resp = (await ApiMsProjectsService.get(`/get_project/${payload.code}`)).data
      commit('SET_CURRENT_PROJECT', resp)
      return resp
    } catch (error) {
      return error
    }
  },
  async getStagesProjects({ commit }, payload = {}) {
    try {
      const resp = (await ApiMsProjectsService.get(`/get_stages_smartsheet`, payload)).data
      commit('SET_STAGES_PROJECTS', resp)
      return resp
    } catch (error) {
      return error
    }
  },
  async getProjectInfo({ commit }, payload = {}) {
    try {
      const resp = (await requestMaterialsService.get(`/api/requests/get_project_info`, payload)).data
      commit('SET_PROJECT_INFO', resp)
      return resp
    } catch (error) {
      return error
    }
  },
  async getUserIsOperational({ commit }, payload = {}) {
    try {
      const resp = (await ApiMsProjectsService.get(`/is_operational`, payload)).data
      return resp
    } catch (error) {
      return error
    }
  },
  async getProjectInfoDetailAndTecnical({ commit }, payload = {}) {
    try {
      const resp = (await ApiMsProjectsService.get(`/get_project_general_info/${payload.projectCode}`, payload)).data
      commit('SET_PROJECT_INFO_DETAIL_AND_TECNICAL', {
        ...resp,
        code: payload.projectCode
      })
      return resp
    } catch (error) {
      return error
    }
  },
  async syncProjects({ commit }) {
    try {
      commit('SET_LOADING_SYNC_PROJECTS', true)
      const resp = await ApiMsProjectsService.post(
        `/manual_update_projects`
      )
      return resp
    } catch (error) {
      return error.resp
    } finally {
      commit('SET_LOADING_SYNC_PROJECTS', false)
    }
  },
  async getSpecialPanels({ commit }, payload = {}) {
    try {
      const resp = (await ApiMsProjectsService.get(`/special_panel_list`, payload)).data
      commit('SET_SPECIAL_PANELS', resp.panels)
      return resp
    } catch (error) {
      console.log(error)
      return error
    }
  },
  setNewSpecialPanel({ commit }, payload) {
    commit('SET_NEW_SPECIAL_PANEL', payload)
  },
  async getFilteredProjects({ commit }, payload = {}) {
    commit('SET_LOADING', true)
    try {
      const resp = (await ApiMsProjectsService.get(`/filtered_projects`, payload)).data
      if (payload.only_payments) {
        return resp
      }
      if (!payload.not_commited) {
        commit('SET_FILTERED_PROJECTS', resp)
      } else {
        commit('SET_LIST_PROJECTS', resp)
      }
      return resp
    } catch (error) {
      return error
    } finally {
      commit('SET_LOADING', false)
    }
  },
  cleanFilteredProjects({ commit }) {
    commit('SET_FILTERED_PROJECTS', [])
  },
  cleanStagesProjects({ commit }) {
    commit('SET_STAGES_PROJECTS', [])
  },
  clearProjectInfo({commit}){
    commit('SET_PROJECT_INFO', {})
  },
  async getTypeProjectProducts({ commit }, payload = {}) {
    try {
      const resp = (await requestMaterialsService.get(`/api/requests/get_projects_re`, payload)).data
      commit('SET_TYPE_PROJECT_PRODUCTS', resp)
      return resp
    } catch (error) {
      return error
    }
  },
  async getSaleOrders({ commit }, payload = {}) {
    try {
      const resp = (await requestMaterialsService.get(`/api/requests/get_subprojects`, payload)).data
      commit('SET_SALE_ORDERS', resp)
      return resp
    } catch (error) {
      return error
    }
  },
  clearSaleOrders({ commit }) {
    commit('SET_SALE_ORDERS', {
      items: [],
      total_pages: 0,
      total_items: 0,
    })
  },

}
